export const createModalOverlay = (contentHtml: string): { overlay: HTMLDivElement; close: () => void } => {
  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.innerHTML = contentHtml;

  document.body.appendChild(overlay);

  requestAnimationFrame(() => {
    overlay.classList.add('visible');
  });

  let handleEscape: (e: KeyboardEvent) => void;

  const close = (): void => {
    overlay.classList.remove('visible');
    setTimeout(() => overlay.remove(), 200);
    document.removeEventListener('keydown', handleEscape);
  };

  handleEscape = (e: KeyboardEvent): void => {
    if (e.key === 'Escape') {
      close();
    }
  };

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', handleEscape);

  return { overlay, close };
};

export const bindModalAction = (
  overlay: HTMLElement,
  selector: string,
  handler: () => void
): void => {
  overlay.querySelector(selector)?.addEventListener('click', handler);
};
